"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fabfitfunSharedGlobal = require("@bit/fabfitfun.shared.global.button");

var _fabfitfunSharedGlobal2 = _interopRequireDefault(_fabfitfunSharedGlobal);

var _HeaderStateProvider = require("./HeaderStateProvider");

var _HeaderStateProvider2 = _interopRequireDefault(_HeaderStateProvider);

var _HeaderContext = require("./HeaderContext");

var _HeaderContext2 = _interopRequireDefault(_HeaderContext);

var _MenuItem = require("./MenuItem/MenuItem");

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _UserMenu = require("./UserMenu/UserMenu");

var _UserMenu2 = _interopRequireDefault(_UserMenu);

var _CartMenu = require("./CartMenu/CartMenu");

var _CartMenu2 = _interopRequireDefault(_CartMenu);

var _MobileCartMenu = require("./CartMenu/MobileCartMenu");

var _MobileCartMenu2 = _interopRequireDefault(_MobileCartMenu);

var _BurgerMenu = require("./BurgerMenu/BurgerMenu");

var _BurgerMenu2 = _interopRequireDefault(_BurgerMenu);

var _defaultRoutes = require("./defaultRoutes.js");

var _defaultRoutes2 = _interopRequireDefault(_defaultRoutes);

var _helperUtils = require("./helperUtils");

var _helperUtils2 = _interopRequireDefault(_helperUtils);

var _fffLogoR = require("./fff-logo-r.svg");

var _fffLogoR2 = _interopRequireDefault(_fffLogoR);

require("./globals.css");

require("./Header.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Header.__proto__ || Object.getPrototypeOf(Header)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isMobile: false
    }, _this.handleResize = function () {
      var mobile = false;

      if (window.innerWidth <= 1199) {
        mobile = true;
      }

      _this.setState({
        isMobile: mobile
      });
    }, _this.goToRoute = function (routeObj) {
      var route = routeObj.route,
          subdomain = routeObj.subdomain,
          inApp = routeObj.inApp;
      var history = _this.props.history;

      if (!route) {
        return;
      }

      if (inApp && history) {
        history.push(route);
        return;
      }

      var domainParts = window.location.hostname.split(".");
      var length = domainParts.length;
      var sub = subdomain ? subdomain + "." : "";
      var domain = "" + sub + domainParts[length - 2] + "." + domainParts[length - 1];
      var url = "https://" + domain + route;
      window.location.href = url;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Header, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _props$avatarUrl = _props.avatarUrl,
          avatarUrl = _props$avatarUrl === undefined ? "" : _props$avatarUrl,
          _props$categories = _props.categories,
          categories = _props$categories === undefined ? [] : _props$categories,
          updateCart = _props.updateCart,
          campaignId = _props.campaignId,
          cart = _props.cart,
          history = _props.history,
          _props$callbacks = _props.callbacks,
          callbacks = _props$callbacks === undefined ? {} : _props$callbacks,
          menuChildren = _props.menuChildren,
          routes = _props.routes,
          selectedCategorySlug = _props.selectedCategorySlug,
          authenticated = _props.authenticated,
          userInfo = _props.userInfo,
          cartLink = _props.cartLink,
          expandProductDetails = _props.expandProductDetails;
      var notice = routes.notice;
      var isMobile = this.state.isMobile;
      var logoStyles = (0, _classnames2.default)({
        "fb-20": !isMobile,
        "mar-a": isMobile
      });
      var logoURL = _helperUtils2.default.staticURL() + "/wp-content/themes/fabfitfun/images/fff-logo.png";
      var userRoutes = routes.mainRoutes.find(function (route) {
        return route.id === "my_account";
      });
      var _routes$buttonRoutes = routes.buttonRoutes,
          buttonRoutes = _routes$buttonRoutes === undefined ? [] : _routes$buttonRoutes;

      if (routes) {
        if (!isMobile) {
          return _react2.default.createElement(_HeaderStateProvider2.default, null, _react2.default.createElement(_HeaderContext2.default.Consumer, null, function (context) {
            var setExpandedMenu = context.setExpandedMenu;
            return _react2.default.createElement("div", {
              className: "fff-header w-100 bcg-white",
              onMouseLeave: function onMouseLeave() {
                return setExpandedMenu({
                  id: ""
                });
              }
            }, notice && notice.links && _react2.default.createElement("div", {
              className: "fff-meta-header"
            }, _react2.default.createElement("div", {
              className: "fff-notice-links flex-jfe d-flex"
            }, notice.links.map(function (item) {
              return _react2.default.createElement("a", {
                onClick: function onClick() {
                  _this2.goToRoute(item);
                },
                className: "cur-pointer",
                key: item.id,
                alt: item.label
              }, _react2.default.createElement("span", {
                dangerouslySetInnerHTML: {
                  __html: item.label
                }
              }));
            }))), _react2.default.createElement("div", {
              className: "fff-header-container pad-16 d-flex flex-jsb flex-aic"
            }, _react2.default.createElement("div", {
              className: logoStyles
            }, _react2.default.createElement("img", {
              className: "fff-header-logo cur-pointer",
              src: _fffLogoR2.default,
              alt: "FabFitFun",
              onClick: function onClick() {
                window.location = _helperUtils2.default.getHomeUrl();
              }
            })), !isMobile && _react2.default.createElement("div", {
              className: "d-flex flex-jsb flex-aic"
            }, _react2.default.createElement("div", {
              className: "fff-header-main-items d-flex flex-aic "
            }, routes.mainRoutes && routes.mainRoutes.filter(function (route) {
              return route.id !== "my_account";
            }).map(function (item) {
              return _react2.default.createElement(_MenuItem2.default, Object.assign({
                authenticated: authenticated,
                key: item.label
              }, item, {
                history: history,
                onClick: _this2.goToRoute,
                userInfo: userInfo
              }));
            })), (!!userRoutes || !!cart) && _react2.default.createElement("div", {
              className: "fff-user-cart-menu d-flex flex-jsb"
            }, !!routes.mainRoutes && authenticated && _react2.default.createElement(_UserMenu2.default, {
              avatarUrl: avatarUrl,
              children: menuChildren,
              routes: userRoutes.subRoutes,
              onClick: _this2.goToRoute,
              userInfo: userInfo
            }), !!cart && authenticated && _react2.default.createElement(_CartMenu2.default, {
              children: menuChildren,
              campaignId: campaignId,
              callbacks: {
                updateCart: updateCart
              },
              data: cart,
              isMobile: false,
              expandProductDetails: expandProductDetails
            }), !!cartLink && !cart && authenticated && _react2.default.createElement("div", {
              className: "cart-menu-btn pad-9 pos-r z-1000"
            }, _react2.default.createElement("button", {
              onClick: function onClick() {
                if (typeof cartLink === "string") {
                  window.location = cartLink;
                } else {
                  window.location = "/add-ons";
                }
              },
              className: "fff-header-cart-button pad-0 cur-pointer pos-r"
            }, _react2.default.createElement("i", {
              className: "fal fa-shopping-cart"
            })))), buttonRoutes.map(function (item) {
              return _react2.default.createElement(_fabfitfunSharedGlobal2.default, {
                type: _fabfitfunSharedGlobal.buttonTypes.PRIMARY.value,
                action: _fabfitfunSharedGlobal.actionTypes.CALL_TO_ACTION.value,
                label: item.label,
                id: item.id,
                alt: item.label,
                style: {
                  borderRadius: 0,
                  whiteSpace: "nowrap"
                },
                onClick: function onClick() {
                  _this2.goToRoute(item.route);
                }
              });
            }))));
          }));
        }

        if (isMobile) {
          return _react2.default.createElement("div", {
            className: "bcg-white fff-header mobile-menu-bar pos-s"
          }, _react2.default.createElement("div", {
            className: "ta-center pad-16"
          }, _react2.default.createElement("img", {
            alt: "FabFitFun",
            className: "mobile-logo mar-a",
            src: _fffLogoR2.default,
            onClick: function onClick() {
              window.location = _helperUtils2.default.getHomeUrl();
            }
          }), !!cart && _react2.default.createElement(_HeaderStateProvider2.default, null, _react2.default.createElement(_CartMenu2.default, {
            children: menuChildren,
            campaignId: campaignId,
            callbacks: {
              updateCart: updateCart
            },
            data: cart,
            isMobile: true
          }), _react2.default.createElement(_HeaderContext2.default.Consumer, null, function (context) {
            var expandedMenu = context.expandedMenu,
                setExpandedMenu = context.setExpandedMenu;

            if (expandedMenu && expandedMenu.id === "mobile-cart") {
              return _react2.default.createElement(_MobileCartMenu2.default, {
                id: "cart-menu",
                callbacks: {
                  updateCart: updateCart,
                  setExpandedMenu: setExpandedMenu
                },
                products: cart.products,
                cartText: cart.cartText,
                campaignId: campaignId,
                total: cart.total,
                children: menuChildren,
                subtotal: cart.subtotal,
                fees: cart.fees,
                remainingCredit: cart.remainingCredit,
                appliedAddonCredit: cart.appliedAddonCredit,
                appliedPurchaseCredit: cart.appliedPurchaseCredit,
                expandProductDetails: expandProductDetails
              });
            }
          })), !!cartLink && !cart && authenticated && _react2.default.createElement("div", {
            className: "cart-menu-btn pad-8 pos-r z-1000"
          }, _react2.default.createElement("button", {
            onClick: function onClick() {
              if (typeof cartLink === "string") {
                window.location = cartLink;
              } else {
                window.location = "/add-ons";
              }
            },
            className: "fff-header-cart-button pad-0 cur-pointer pos-r"
          }, _react2.default.createElement("i", {
            className: "fal fa-shopping-cart"
          })))), _react2.default.createElement(_BurgerMenu2.default, {
            categories: categories,
            children: menuChildren,
            routes: routes,
            logoURL: logoURL,
            history: history,
            userInfo: userInfo,
            openCategories: this.state.menuOpenCategories,
            callbacks: {
              handleClickCategory: callbacks.handleClickCategory,
              toggleOpenCategory: this.toggleOpenCategory
            },
            selectedCategorySlug: selectedCategorySlug
          }));
        }
      }

      return null;
    }
  }]);

  return Header;
}(_react.Component);

Header.defaultProps = {
  routes: _defaultRoutes2.default
};
Header.propTypes = {
  history: _propTypes2.default.object,
  isMobile: _propTypes2.default.bool,
  routes: _propTypes2.default.object,
  categories: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  cart: _propTypes2.default.object,
  selectedCategorySlug: _propTypes2.default.string
};
exports.default = Header;